import { useEffect } from 'react'
import { fetchCurrentWorkbench, selectCurrentWorkbench, selectCurrentWorkbenchId, selectIsLoadingCurrentWorkbench } from '@state/reducers/workbenchReducer'
import { useAppDispatch, useAppSelector } from './reduxHooks'

export const useCurrentWorkbench = () => {
  const dispatch = useAppDispatch()
  const id = useAppSelector(selectCurrentWorkbenchId)
  const currentWorkbench = useAppSelector(selectCurrentWorkbench)

  useEffect(() => {
    if (id) {
      dispatch(fetchCurrentWorkbench(id))
    }
  }, [id])

  const isLoading = useAppSelector(selectIsLoadingCurrentWorkbench)

  return { currentWorkbench, isLoading }
}
